import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["headerTitle", "currentActiveTab", "tabElements", "commentCount", "commentCountRefetch", "topRightButton", "onTabClick"];
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import { GroupTab, Tab } from "client/componentLibrary";
import { Tabs as MuiTabs, Box, RaiseColors, Typography, makeStyles, useTheme } from "componentLibrary";
import useWindowSize from "hooks/useWindowSize";
import classNames from "classnames";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NAV_HEIGHT_DESKTOP = 110;
var NAV_HEIGHT_MOBILE = 102;
var NAV_HEIGHT_NO_TABS = 64;
var MOBILE_PADDING = 20;
var MD_PADDING = 28;
var TABLET_PADDING = 36;
var LAPTOP_PADDING = 48;
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      responsiveWrapper: function responsiveWrapper(hasTabs) {
        return _defineProperty({
          width: "100%",
          position: "sticky",
          top: 0,
          backgroundColor: RaiseColors.neutral100,
          zIndex: 3,
          display: hasTabs ? "block" : "none",
          boxShadow: hasTabs ? "0px 1px 5px ".concat(RaiseColors.midnight, "14") : "none"
        }, theme.breakpoints.up("xl"), {
          display: "block"
        });
      },
      navPlaceHolder: _defineProperty({
        width: "100%",
        height: NAV_HEIGHT_MOBILE
      }, theme.breakpoints.up("laptop"), {
        height: NAV_HEIGHT_DESKTOP
      }),
      navPlaceHolderNoTabs: {
        width: "100%",
        height: NAV_HEIGHT_NO_TABS
      },
      container: _defineProperty(_defineProperty(_defineProperty({
        position: "absolute",
        zIndex: 10,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        paddingLeft: MOBILE_PADDING,
        paddingRight: MOBILE_PADDING,
        height: NAV_HEIGHT_MOBILE,
        backgroundColor: RaiseColors.white,
        maxWidth: "100vw",
        overflow: "hidden",
        top: 0
      }, theme.breakpoints.up("md"), {
        paddingLeft: MD_PADDING,
        paddingRight: MD_PADDING
      }), theme.breakpoints.up("tablet"), {
        paddingLeft: TABLET_PADDING,
        paddingRight: TABLET_PADDING
      }), theme.breakpoints.up("laptop"), {
        paddingLeft: LAPTOP_PADDING,
        paddingRight: LAPTOP_PADDING,
        height: NAV_HEIGHT_DESKTOP
      }),
      containerNoTabs: _defineProperty(_defineProperty(_defineProperty({
        position: "absolute",
        zIndex: 10,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        paddingLeft: MOBILE_PADDING,
        paddingRight: MOBILE_PADDING,
        height: NAV_HEIGHT_NO_TABS,
        backgroundColor: RaiseColors.white,
        maxWidth: "100vw",
        overflow: "hidden",
        top: 0
      }, theme.breakpoints.up("md"), {
        paddingLeft: MD_PADDING,
        paddingRight: MD_PADDING
      }), theme.breakpoints.up("tablet"), {
        paddingLeft: TABLET_PADDING,
        paddingRight: TABLET_PADDING
      }), theme.breakpoints.up("laptop"), {
        paddingLeft: LAPTOP_PADDING,
        paddingRight: LAPTOP_PADDING,
        height: NAV_HEIGHT_NO_TABS
      }),
      containerWithNav: {
        paddingTop: "16px"
      },
      containerHeaderOnly: {
        display: "flex",
        alignItems: "center",
        height: NAV_HEIGHT_NO_TABS
      },
      tabsRoot: {
        maxWidth: "100vw",
        "& .MuiTabs-scrollButtons": {
          display: "none"
        }
      },
      tabsFlexContainer: {
        "& > .MuiTab-root:first-child": {
          marginLeft: 0
        }
      },
      /// We need to replace the built in indicator w/ a span to give greater flexibility on customizing it
      /// https://material-ui.com/components/tabs/#customized-tabs
      tabsIndicator: {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent",
        "& > span": {
          maxWidth: "32px",
          width: "100%",
          height: "2px",
          marginTop: "-10px",
          backgroundColor: RaiseColors.blue500
        }
      },
      header: {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        width: "calc(100% - 60px)"
      },
      headerWrapper: {
        width: "100%"
      }
    };
  });
};
var TopBar = function TopBar(_ref2) {
  var _useWindowSize$innerW;
  var headerTitle = _ref2.headerTitle,
    _ref2$currentActiveTa = _ref2.currentActiveTab,
    currentActiveTab = _ref2$currentActiveTa === void 0 ? {
      parent: 0,
      group: -1
    } : _ref2$currentActiveTa,
    _ref2$tabElements = _ref2.tabElements,
    tabElements = _ref2$tabElements === void 0 ? [] : _ref2$tabElements,
    commentCount = _ref2.commentCount,
    commentCountRefetch = _ref2.commentCountRefetch,
    _ref2$topRightButton = _ref2.topRightButton,
    topRightButton = _ref2$topRightButton === void 0 ? /*#__PURE__*/_jsx(_Fragment, {}) : _ref2$topRightButton,
    onTabClick = _ref2.onTabClick,
    props = _objectWithoutProperties(_ref2, _excluded);
  var hasTabs = tabElements && tabElements.length > 0;
  var theme = useTheme();
  var classes = useStyles()(hasTabs);
  var handleTabChange = function handleTabChange(event, newValue) {
    onTabClick === null || onTabClick === void 0 || onTabClick({
      parent: newValue,
      group: -1
    });
  };
  var handleGroupTabChange = function handleGroupTabChange(parentIndex, groupIndex) {
    onTabClick === null || onTabClick === void 0 || onTabClick({
      parent: parentIndex,
      group: groupIndex
    });
  };
  var windowSize = (_useWindowSize$innerW = useWindowSize().innerWidth) !== null && _useWindowSize$innerW !== void 0 ? _useWindowSize$innerW : 0;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Box, {
      className: classes.responsiveWrapper,
      children: [/*#__PURE__*/_jsx("div", {
        className: hasTabs ? classes.navPlaceHolder : classes.navPlaceHolderNoTabs
      }), /*#__PURE__*/_jsxs(Box, {
        className: hasTabs ? classes.container : classes.containerNoTabs,
        children: [/*#__PURE__*/_jsxs(Box, {
          className: classNames(classes.headerWrapper, hasTabs ? classes.containerWithNav : classes.containerHeaderOnly),
          "data-testid": "header-tabs-container",
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h3",
            weight: "medium",
            classes: {
              root: classes.header
            },
            children: headerTitle
          }), hasTabs && /*#__PURE__*/_jsx(MuiTabs, {
            value: currentActiveTab.parent,
            classes: {
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
              flexContainer: classes.tabsFlexContainer
            },
            style: {
              marginTop: windowSize >= _valuesInstanceProperty(theme.breakpoints).laptop ? "24px" : "16px"
            },
            TabIndicatorProps: {
              children: /*#__PURE__*/_jsx("span", {})
            },
            onChange: handleTabChange,
            variant: "scrollable",
            scrollButtons: false,
            children: _mapInstanceProperty(tabElements).call(tabElements, function (tab, index) {
              return tab.group ? /*#__PURE__*/_jsx(GroupTab, {
                label: tab.label,
                activeValue: currentActiveTab.parent,
                activeGroupValue: currentActiveTab.group,
                tabGroup: tab.group,
                onGroupTabChange: handleGroupTabChange
              }, index) : /*#__PURE__*/_jsx(Tab, {
                label: tab.label,
                activeValue: currentActiveTab.parent
              }, index);
            })
          })]
        }), topRightButton]
      })]
    })
  });
};
export default TopBar;